import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { RefSetter } from '../Utils/RefSetter';
import { FieldName } from '../Types/Intyg.enums';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { IAppContext, ValidationError } from '../Types/Intyg.types';

export interface IVillkorProps {}
export interface IVillkorState extends FormSectionBaseState {}

enum LocalErrorName {
  Villkor = 'VILLKOR',
}

export default class Villkor extends FormSectionBase<IVillkorProps, IVillkorState> {
  constructor(props: IVillkorProps, context: IAppContext) {
    super(props);

    this.fieldRefs.set(FieldName.VillkorCheckbox, React.createRef<CheckBox>());

    const initialError = new Map(this.emptyErrorsMap);
    initialError.set(LocalErrorName.Villkor, this.getMandatoryMessage(false, context));

    this.state = {
      errors: initialError,
    };
  }

  onChangeCheckbox = (field: FormField<CheckBox>) => {
    const errors = new Map(this.state.errors);
    this.context.isFormTouched = true;
    if (field.value) {
      errors.delete(LocalErrorName.Villkor);
    } else {
      errors.set(LocalErrorName.Villkor, this.getMandatoryMessage());
    }
    this.setState({ errors }, () => {
      this.context.submitButtonIsClicked = true;
      this.context.forceComponentTreeReRender();
    });
  };

  getMandatoryMessage = (showMessage: boolean = true, context = this.context): ValidationError => {
    return { errorMessage: context.Translate('error_mandatory'), showMessage };
  };

  public render() {
    const { isInEditMode, Translate } = this.context;
    const label = this.findProperty('SamtyckeLabel');
    const explanation = this.findProperty('SamtyckeExplanation');

    return (
      <>
        {(explanation || isInEditMode) && (
          <EpiserverProperty
            propertyName="SamtyckeExplanation"
            usingDangerouslySetInnerHTML={true}
            isInEditMode={isInEditMode}>
            <div dangerouslySetInnerHTML={setInnerHtml(explanation)}></div>
          </EpiserverProperty>
        )}
        {isInEditMode && (
          <EpiserverProperty
            propertyName="SamtyckeLabel"
            usingDangerouslySetInnerHTML={true}
            isInEditMode={isInEditMode}>
            <div dangerouslySetInnerHTML={setInnerHtml(label)}></div>
          </EpiserverProperty>
        )}
        <RefSetter fieldRefs={this.fieldRefs}>
          <CheckBox
            isRequired={true}
            fieldName={FieldName.VillkorCheckbox}
            errorMessage={this.getErrorMessage(LocalErrorName.Villkor)}
            label={label}
            disabled={isInEditMode}
            onChange={this.onChangeCheckbox}
          />
        </RefSetter>
        {this.fieldRefs.get(LocalErrorName.Villkor) && <input type="hidden" name="samtycke" value={Translate('nej')} />}
        {!this.fieldRefs.get(LocalErrorName.Villkor) && <input type="hidden" name="samtycke" value={Translate('ja')} />}
      </>
    );
  }
}
